import React, { useState, useEffect, useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Summary,
  TotalItem,
  Pager,
  Paging,
  Button,
  MasterDetail,
} from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import useDeviceSize from "../hooks/useDeviceSize";
import useLocalStorage from "../hooks/useLocalStorage";
import Guid from "devextreme/core/guid";
import axios from "axios";
import swal from "sweetalert";
import BookingsMasterDetailView from "./BookingsMasterDetailView2";
import CancelData from "../components/BookingCancelConditionModal";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import "../modal.css";
import DataView from "./BookingCancelDataView";
import { useSearchParams } from "react-router-dom";
import { api_path ,token} from "../shared";
export function BookingsDataGrid(props) {
  const classes = useStyles();
  const [searchParams] = useSearchParams();
  const getLoad = searchParams.get("load");
  const [getCRM_ID, setCRM_ID] = useState(props.CRM_ID);
  const [getSubject, setSubject] = useState();
  const [getTotalCount, setTotalCount] = useState();
  const [getCheckbox, setCheckbox] = useState();
  const [getAvai, setAvai] = useLocalStorage("getAvai", false);
  const [getLock, setLock] = useLocalStorage("getLock", false);
  const [getCf, setCf] = useLocalStorage("getCf", false);
  const [getCancel, setCancel] = useLocalStorage("getCancel", false);
  const [getLoadGrid, setLoadGrid] = useState();
  const [GET_NOTE, SET_NOTE] = useState();
  const [GET_CS_NAME, SET_CS_NAME] = useState();
  const [GET_CS_BY, SET_CS_BY] = useState();
  const [GET_NEW_CS, SET_NEW_CS] = useState();
  const [GET_BOOKING_NO, SET_BOOKING_NO] = useState();
  const [GET_SHIPPER, SET_SHIPPER] = useState();
  const [GET_CARRIER, SET_CARRIER] = useState();
  const [GET_ETD, SET_ETD] = useState();
  const [GET_DISCHARGE, SET_DISCHARGE] = useState();
  const [GET_TYPE, SET_TYPE] = useState();
  const [GET_20, SET_20] = useState();
  const [GET_40, SET_40] = useState();
  const [GET_40HQ, SET_40HQ] = useState();
  const [GET_SALES, SET_SALES] = useState();
  const [GET_CANCEL_CUTOFF, SET_CANCEL_CUTOFF] = useState();

  const [GET_CTNR_CUTOFF, SET_CTNR_CUTOFF] = useState();
  const [GET_TIME, SET_TIME] = useState();
  const [GET_WARNING1, SET_WARNING1] = useState();
  const [GET_WARNING2, SET_WARNING2] = useState();
  const [GET_CF_COMMENT, SET_CF_COMMENT] = useState();
  const [GET_AVAILABLE, SET_AVAILABLE] = useState();
  const [GET_UPDATE_BY, SET_UPDATE_BY] = useState();



    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  const url =
    api_path +
    "/GET_BOOKINGS.php?token="+
    token +
    "&avai=" +
    getAvai +
    "&lock=" +
    getLock +
    "&cf=" +
    getCf +
    "&cancel=" +
    getCancel +
    "&uid=" +
    getCRM_ID +
    "&load=" +
    getLoadGrid;
  let today = new Date();
  let getDateNow =
    today.toLocaleString("en-us", { weekday: "long" }) +
    "," +
    today.getDate() +
    " " +
    today.toLocaleString("default", { month: "long" }) +
    "," +
    today.getFullYear();
  const dataSource = createStore({
    key: "BOOKING_ID",
    loadUrl: `${url}`,
  });


  const pageSizes = [25, 50, 100, 200];
  const [width, height] = useDeviceSize();
  const [getBookingData, setBookingData] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(api_path + "/BC_MS_CARRIER.php?type=1");
    const data = await response.json();
    setBookingData(data);
  };
  const onAddQueueButtonClickIn = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    if (dataRow.name_status == "Canceled") {
      swal({
        title: "Sorry...",
        text: "This booking has been cancel.",
        icon: "warning",
      });
    } else if (dataRow.BOOKING_STATUS == "available") {
      swal({
        title: "Sorry...",
        text: "This booking status is available for CF.",
        icon: "warning",
      });
    } else {
      swal({
        title: "Are you sure?",
        text: "In queue.",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          addQueue(e.row.key);
        }
      });
    }
  }, []);
  const onAddQueueButtonClickOut = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    if (dataRow.name_status == "Canceled") {
      swal({
        title: "Sorry...",
        text: "This booking has been cancel.",
        icon: "warning",
      });
    } else {
      swal({
        title: "Are you sure?",
        text: "Out queue.",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          addQueue(e.row.key);
        }
      });
    }
  }, []);
    
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random()
        * (max - min + 1)) + min;
};
  const addQueue = async (id) => {
    try {
      const response = await axios.get(
        api_path + `/BC_TS_BOOKING_Q.php?id=${id}&uid=${getCRM_ID}`
      );
      setLoadGrid(randomNumberInRange(1,20))
    } catch (error) {
      console.error(error);
    }
  };
  const handleChangeCheck1 = (event) => {
    if (event.target.checked) {
      localStorage.setItem("Checkbox1", event.target.checked);
      console.log("✅ Available is checked");
      setAvai(1);
    } else {
      console.log("⛔️ Available is NOT checked");
      setAvai(0);
    }
  };
  const handleChangeCheck2 = (event) => {
    if (event.target.checked) {
      localStorage.setItem("Checkbox2", event.target.checked);
      console.log("✅ Locked is checked");
      setLock(1);
    } else {
      console.log("⛔️ Locked is NOT checked");
      setLock(0);
    }
  };
  const handleChangeCheck3 = (event) => {
    if (event.target.checked) {
      localStorage.setItem("Checkbox3", event.target.checked);
      console.log("✅ CF is checked");
      setCf(1);
    } else {
      console.log("⛔️ CF is NOT checked");
      setCf(0);
    }
  };
  const handleChangeCheck4 = (event) => {
    if (event.target.checked) {
      localStorage.setItem("Checkbox4", event.target.checked);
      console.log("✅ Cancel is checked");
      setCancel(1);
    } else {
      console.log("⛔️ Cancel is NOT checked");
      setCancel(0);
    }
  };
  const onViewNoteButtonClick = (event) => {};

  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];

  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };

 const isAddCart = (BOOKING_STATUS) =>
    BOOKING_STATUS && ["available"].indexOf(BOOKING_STATUS) >= 0;
  const CFVisible = (e) => isAddCart(e.row.data.BOOKING_STATUS);

  const haveQ = (ALLQ) =>
    ALLQ && ["1"].indexOf(ALLQ) >= 0;
  const haveQVisible = (e) => haveQ(e.row.data.MY_Q);
  const NoQVisible = (e) => !haveQ(e.row.data.MY_Q) && !isAddCart(e.row.data.BOOKING_STATUS);

    

  const haveNote = (position) =>
    position && ["1"].indexOf(position.trim().toUpperCase()) >= 0;
  const haveNoteVisible = (e) => haveNote(e.row.data.HAS_NOTE);
  const NotHaveNoteVisible = (e) => !haveNote(e.row.data.HAS_NOTE);
  const cellPrepared = (e) => {
    setTotalCount(e.component.totalCount());
    if (e.rowType === "data") {
      if (
        e.column.dataField === "name_status" &&
        e.data.code_status == 1 //To be Canceled
      ) {
        e.cellElement.style.cssText =
          "color: red; background-color: #FFB5B5; text-align:center;";
      } else if (
        e.column.dataField === "name_status" &&
        e.data.code_status == 2 //2nd Warning
      ) {
        e.cellElement.style.cssText =
          "color: #FF5500; background-color: #FFDEBC; text-align:center;";
      } else if (
        e.column.dataField === "name_status" &&
        e.data.code_status == 3 //1st Warning
      ) {
        e.cellElement.style.cssText =
          "color: #616004; background-color: #FFF2C9; text-align:center;";
      } else if (
        e.column.dataField === "name_status" &&
        e.data.code_status == 4 //Processing
      ) {
        e.cellElement.style.cssText =
          "color: #006100; background-color: #C6EFCE; text-align:center;";
      } else if (
        e.column.dataField === "name_status" &&
        e.data.code_status == 0 //cancel
      ) {
        e.cellElement.style.cssText =
          "color:#FFF; background-color: red; text-align:center;";
        } else if (
          e.column.dataField === "name_status" &&
          e.data.code_status == 5 //fc
        ) {
          e.cellElement.style.cssText =
            "color:#FFF; background-color: #FF5D00; text-align:center;";
      } else if (
        e.column.dataField === "CONTAINER_TYPE" &&
        e.data.CONTAINER_TYPE == "FAK"
      ) {
        e.cellElement.innerHTML = "📦 FAK";
      } else if (
        e.column.dataField === "CONTAINER_TYPE" &&
        e.data.CONTAINER_TYPE == "NAC"
      ) {
        e.cellElement.innerHTML = "👨🏻‍💼 NAC";
      } else if (
        e.column.dataField === "CONTAINER_TYPE" &&
        e.data.CONTAINER_TYPE == "REEFER"
      ) {
        e.cellElement.innerHTML = "🧊 REEFER";
      } else if (
        e.column.dataField === "CONTAINER_TYPE" &&
        e.data.CONTAINER_TYPE == "GARMENT"
      ) {
        e.cellElement.innerHTML = "👗 GARMENT";
      } else if (
        e.column.dataField === "CONTAINER_TYPE" &&
        e.data.CONTAINER_TYPE == "FOOD"
      ) {
        e.cellElement.innerHTML = "🍽️ FOOD";
      } else if (
        e.column.dataField === "CONTAINER_TYPE" &&
        e.data.CONTAINER_TYPE == "DG"
      ) {
        e.cellElement.innerHTML = "☠️ DG";
      } else if (
        e.column.dataField === "CONTAINER_TYPE" &&
        e.data.CONTAINER_TYPE == "DG"
      ) {
        e.cellElement.innerHTML = "☠️ DG";
      } else if (e.column.dataField === "ALL_Q" && e.data.ALL_Q == "0") {
        e.cellElement.innerHTML = "";
        e.cellElement.style.cssText = "text-align:center;";
      } else if (e.column.dataField === "ALL_Q" && e.data.ALL_Q > "0") {
        if (e.data.ALL_Q === "1") {
          e.cellElement.innerHTML =
            "<a href='QueueDetail?param=" +
            e.row.key +
            "'  title='View Queue' target='_blank'> 🚶(" +
            e.data.ALL_Q +
            ")</a>";
        } else if (e.data.ALL_Q === "2") {
          e.cellElement.innerHTML =
            "<a href='QueueDetail?param=" +
            e.row.key +
            "'  title='View Queue' target='_blank'> 🚶🚶(" +
            e.data.ALL_Q +
            ")</a>";
        } else if (e.data.ALL_Q === "3") {
          e.cellElement.innerHTML =
            "<a href='QueueDetail?param=" +
            e.row.key +
            "'  title='View Queue' target='_blank'> 🚶🚶🚶(" +
            e.data.ALL_Q +
            ")</a>";
        } else if (e.data.ALL_Q === "4") {
          e.cellElement.innerHTML =
            "<a href='QueueDetail?param=" +
            e.row.key +
            "'  title='View Queue' target='_blank'> 🚶🚶🚶🚶(" +
            e.data.ALL_Q +
            ")</a>";
        } else {
          e.cellElement.innerHTML =
            "<a href='QueueDetail?param=" +
            e.row.key +
            "'  title='View Queue' target='_blank'> 🚶🚶🚶🚶🚶(" +
            e.data.ALL_Q +
            ")</a>";
        }

        e.cellElement.style.cssText = "text-align:center;";
      } else if (
        e.column.dataField === "BOOKING_STATUS" &&
        e.data.BOOKING_STATUS == "locked"
      ) {
        e.cellElement.style.cssText =
          "color: #000000; background-color: rgb(255, 181, 181); text-align:center;";
      } else if (
        e.column.dataField === "BOOKING_STATUS" &&
        e.data.BOOKING_STATUS == "available"
      ) {
        e.cellElement.style.cssText =
          "color: #000000; background-color: #C6EFCE; text-align:center;";
      } else if (
        e.column.dataField === "BOOKING_STATUS" &&
        e.data.BOOKING_STATUS == "cf"
      ) {
        e.cellElement.style.cssText =
          "color: #000000; background-color: rgb(255, 201, 99); text-align:center;";
      // } else if (
      //   e.column.dataField === "BOOKING_NO" &&
      //   e.data.code_status == 5
      // ) {
      //   e.cellElement.style.cssText =
      //     "color: #FFF; background-color: #119f4a; text-align:center;";
      }
    }
  };

  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      // style: "currency",
      // currency: "USD",
    }).format(value);
  const customizeText = (cellInfo) => {
    if (
      cellInfo.value === "1900-01-01 00:00:00.000" ||
      cellInfo.value === "" ||
      cellInfo.value === null ||
      cellInfo.value === undefined
    ) {
      return "-";
    } else {
      return cellInfo.valueText;
    }
  };
  const isComplete = (status) =>
    status && ["3"].indexOf(status.trim().toUpperCase()) >= 0;
  const isRatingIconVisible = (e) => isComplete(e.row.data.STATUS_ID);
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Bookings.xlsx"
        );
      });
    });
  };
  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const [selectedValue, setSelectedValue] = useState("1");
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  useEffect(() => {
    dataSource.load()
    .then(
        (data) => { console.log("load data...") },
        (error) => { /* Handle the "error" here */ }
    )
  });
  useEffect(() => {
    if (localStorage.getItem("getAvai") == true) {
      setAvai(1);
    } else {
      setAvai(0);
    }
    if (localStorage.getItem("getLock") == true) {
      setLock(1);
    } else {
      setLock(0);
    }
    if (localStorage.getItem("getCf") == true) {
      setCf(1);
    } else {
      setCf(0);
    }
    if (localStorage.getItem("getCancel") == true) {
      setCancel(1);
    } else {
      setCancel(0);
    }
  }, []);

  function refreshPage() {
    window.location.reload(false);
  }

  useEffect(() => {
    //if (getLoad == "1") {
      const expires = Number(
        localStorage.getItem("Expires") ?? Date.now() + 5 * 60 * 1000
      );
      localStorage.setItem("Expires", expires.toString());
      let tid: number | undefined;
      let timeLeft = expires - Date.now();
      const countdown = (t: number) => {
        if (timeLeft > 0) {
          tid = window.setTimeout(() => {
            setLoadGrid(randomNumberInRange(1,20))
            timeLeft = timeLeft - t;
            countdown(600 * 1000);
          }, t);
        } else {
          localStorage.removeItem("Expires");
        }
      };
      countdown(timeLeft % (600 * 1000) || 600 * 1000);
      return () => {
        clearTimeout(tid);
      };
    //}
  },);
  function onAddCartButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    setShow(true)
    //SET_ITEM_ID(dataRow.SALES_ORDER_ITEM_ID);
    //SET_BOOKING_NO(dataRow.BOOKINGNO);
    //SET_BOOKING_REF(dataRow.BOOKINGREF);
  }
 
  return (
    <Container maxWidth="xl">
       <Modal
              className="modal"
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>CF Booking</Modal.Title>
                <Button1 variant="secondary" onClick={handleClose}>
                  Close
                </Button1>
              </Modal.Header>
              <Modal.Body>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                  <label>CS NAME:</label>
                  <TextField
                    size="small"
                    name="GET_CS_NAME"
                    variant="outlined"
                    fullWidth
                    id="GET_CS_NAME"
                    value={GET_CS_NAME}
                    onChange={(e) => SET_CS_NAME(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>CF BY:</label>
                  <TextField
                    size="small"
                    name="GET_CS_BY"
                    variant="outlined"
                    fullWidth
                    id="GET_CS_BY"
                    value={GET_CS_BY}
                    onChange={(e) => SET_CS_BY(e.target.value)}
                  />
                </Grid>
                  <Grid item xs={12} sm={3}>
                 <label>NEW CS:</label>
                  <TextField
                    size="small"
                    name="GET_NEW_CS"
                    variant="outlined"
                    fullWidth
                    id="GET_NEW_CS"
                    value={GET_NEW_CS}
                    onChange={(e) => SET_NEW_CS(e.target.value)}
                  />
                </Grid>
                 <Grid item xs={12} sm={3}>
                  <label>BOOKING NO:</label>
                  <TextField
                    size="small"
                    name="GET_BOOKING_NO"
                    variant="outlined"
                    fullWidth
                    id="GET_BOOKING_NO"
                    value={GET_BOOKING_NO}
                    onChange={(e) => SET_BOOKING_NO(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>SHIPPER:</label>
                  <TextField
                    size="small"
                    name="GET_SHIPPER"
                    variant="outlined"
                    fullWidth
                    id="GET_SHIPPER"
                    value={GET_SHIPPER}
                    onChange={(e) => SET_SHIPPER(e.target.value)}
                  />
                </Grid>
                  <Grid item xs={12} sm={3}>
                 <label>CARRIER:</label>
                  <TextField
                    size="small"
                    name="GET_CARRIER"
                    variant="outlined"
                    fullWidth
                    id="GET_CARRIER"
                    value={GET_CARRIER}
                    onChange={(e) => SET_CARRIER(e.target.value)}
                  />
                </Grid>


                       <Grid item xs={12} sm={3}>
                  <label>ETD:</label>
                  <TextField
                    size="small"
                    name="GET_ETD"
                    variant="outlined"
                    fullWidth
                    id="GET_ETD"
                    value={GET_ETD}
                    onChange={(e) => SET_ETD(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>DISCHARGE:</label>
                  <TextField
                    size="small"
                    name="GET_DISCHARGE"
                    variant="outlined"
                    fullWidth
                    id="GET_DISCHARGE"
                    value={GET_DISCHARGE}
                    onChange={(e) => SET_DISCHARGE(e.target.value)}
                  />
                </Grid>
                  <Grid item xs={12} sm={3}>
                 <label>TYPE:</label>
                  <TextField
                    size="small"
                    name="GET_TYPE"
                    variant="outlined"
                    fullWidth
                    id="GET_TYPE"
                    value={GET_TYPE}
                    onChange={(e) => SET_TYPE(e.target.value)}
                  />
                </Grid>



                       <Grid item xs={12} sm={3}>
                  <label>20':</label>
                  <TextField
                    size="small"
                    name="GET_20"
                    variant="outlined"
                    fullWidth
                    id="GET_20"
                    value={GET_20}
                    onChange={(e) => SET_20(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>40':</label>
                  <TextField
                    size="small"
                    name="GET_40"
                    variant="outlined"
                    fullWidth
                    id="GET_40"
                    value={GET_40}
                    onChange={(e) => SET_40(e.target.value)}
                  />
                </Grid>
                  <Grid item xs={12} sm={3}>
                 <label>40HQ:</label>
                  <TextField
                    size="small"
                    name="GET_40HQ"
                    variant="outlined"
                    fullWidth
                    id="GET_40HQ"
                    value={GET_40HQ}
                    onChange={(e) => SET_40HQ(e.target.value)}
                  />
                </Grid>


                       <Grid item xs={12} sm={3}>
                  <label>SALES:</label>
                  <TextField
                    size="small"
                    name="GET_SALES"
                    variant="outlined"
                    fullWidth
                    id="GET_SALES"
                    value={GET_SALES}
                    onChange={(e) => SET_SALES(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>CANCEL BKG CUTOFF:</label>
                  <TextField
                    size="small"
                    name="GET_CANCEL_CUTOFF"
                    variant="outlined"
                    fullWidth
                    id="GET_CANCEL_CUTOFF"
                    value={GET_CANCEL_CUTOFF}
                    onChange={(e) => SET_CANCEL_CUTOFF(e.target.value)}
                  />
                </Grid>
                  <Grid item xs={12} sm={3}>
                 <label>CTNR CUTOFF DATE:</label>
                  <TextField
                    size="small"
                    name="GET_CTNR_CUTOFF"
                    variant="outlined"
                    fullWidth
                    id="GET_CTNR_CUTOFF"
                    value={GET_CTNR_CUTOFF}
                    onChange={(e) => SET_CTNR_CUTOFF(e.target.value)}
                  />
                </Grid>




                  <Grid item xs={12} sm={3}>
                  <label>Time:</label>
                  <TextField
                    size="small"
                    name="GET_TIME"
                    variant="outlined"
                    fullWidth
                    id="GET_TIME"
                    value={GET_TIME}
                    onChange={(e) => SET_TIME(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>1ST WARNING:</label>
                  <TextField
                    size="small"
                    name="GET_WARNING1"
                    variant="outlined"
                    fullWidth
                    id="GET_WARNING1"
                    value={GET_WARNING1}
                    onChange={(e) =>SET_WARNING1(e.target.value)}
                  />
                </Grid>
                  <Grid item xs={12} sm={3}>
                 <label>2ND WARNING:</label>
                  <TextField
                    size="small"
                    name="GET_WARNING2"
                    variant="outlined"
                    fullWidth
                    id="GET_WARNING2"
                    value={GET_WARNING2}
                    onChange={(e) => SET_WARNING2(e.target.value)}
                  />
                </Grid>



                  <Grid item xs={12} sm={3}>
                  <label>CF COMMENT:</label>
                  <TextField
                    size="small"
                    name="GET_CF_COMMENT"
                    variant="outlined"
                    fullWidth
                    id="GET_CF_COMMENT"
                    value={GET_CF_COMMENT}
                    onChange={(e) => SET_CF_COMMENT(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>AVAILABLE:</label>
                  <TextField
                    size="small"
                    name="GET_AVAILABLE"
                    variant="outlined"
                    fullWidth
                    id="GET_AVAILABLE"
                    value={GET_AVAILABLE}
                    onChange={(e) => SET_AVAILABLE(e.target.value)}
                  />
                </Grid>
                  <Grid item xs={12} sm={3}>
                 <label>UPDATE BY:</label>
                  <TextField
                    size="small"
                    name="GET_UPDATE_BY"
                    variant="outlined"
                    fullWidth
                    id="GET_UPDATE_BY"
                    value={GET_UPDATE_BY}
                    onChange={(e) => SET_UPDATE_BY(e.target.value)}
                  />
                </Grid>
                  
               
                <Grid item xs={12} sm={6}>
                  <label>Note:</label>
                  <TextField
                    size="small"
                    name="GET_NOTE"
                    variant="outlined"
                    fullWidth
                    id="GET_NOTE"
                    value={GET_NOTE}
                    onChange={(e) => SET_NOTE(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                
                </Grid>
                </Grid>
              </Modal.Body>
              <Modal.Footer>
                <Button1 variant="secondary" onClick={handleClose}>
                  Close
                </Button1>
              </Modal.Footer>
            </Modal>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">Preserve Booking</label>
      </Grid>
      <Grid container spacing={2}>
        &nbsp;
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormGroup row style={{ display: "flex", flexDirection: "row" }}>
            <label className="btn btn-avai">
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Available"
                onChange={handleChangeCheck1}
                checked={getAvai}
              />
            </label>
            &nbsp;
            <label className="btn btn-lock">
              <FormControlLabel
                control={<Checkbox />}
                label="Locked"
                onChange={handleChangeCheck2}
                checked={getLock}
              />
            </label>
            &nbsp;
            <label className="btn btn-cf">
              <FormControlLabel
                control={<Checkbox />}
                label="CF"
                onChange={handleChangeCheck3}
                checked={getCf}
              />
            </label>
            &nbsp;
            <label className="btn btn-cf2">
              <FormControlLabel
                control={<Checkbox />}
                label="Cancelled"
                onChange={handleChangeCheck4}
                checked={getCancel}
              />
            </label>
          </FormGroup>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button1
            type="button"
            variant="contained"
            className="btn-clear"
            onClick={refreshPage}
          >
            Click to reload!
          </Button1>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          style={{ display: "flex" }}
          justify-content="flex-end"
        >
          <div className="boxDesc">
            <label>
              1st warning = before Cancel Booking cutoff date 5 days
            </label>{" "}
            <br />
            <label>
              2nd warning = before Cancel Booking cutoff date 2 days
            </label>{" "}
            <br />
            <label>
              Cancel Booking cutoff criteria
              <CancelData />
      
            </label>
          </div>
        </Grid>
        <Grid item xs={12} sm={12}>
          <div className="labelResult">
            Available Preserve Booking For ETD >= {getDateNow}
          </div>
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="AgentID"
          onExporting={onExporting}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
            mode="virtual"
          ></Scrolling>
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <MasterDetail enabled={true} component={BookingsMasterDetailView} />
          {/* <Selection mode="multiple" /> */}
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column dataField="BOOKING_ID" visible={false} />
          <Column dataField="BOOKING_STATUS" caption="Status" width={90} />
          <Column
            dataField="name_status"
            caption="Cancel Warning"
            width={120}
          />
          <Column
            dataField="BOOKING_NO"
            caption="Booking No"
            allowHiding={false}
            width={130}
          />
          <Column dataField="MY_Q" visible={false} />
          <Column dataField="HAS_Q" visible={false} />
          <Column dataField="HAS_NOTE" visible={false} />
          <Column type="buttons" caption="Q" width={50}>
            <Button
              text="🤍"
              name=""
              onClick={onAddQueueButtonClickIn}
              visible={NoQVisible}
              hint="In queue"
            />
            <Button
              text="❤️"
              name=""
              onClick={onAddQueueButtonClickOut}
              visible={haveQVisible}
              hint="Out queue"
              width={50}
            />
            <Button
              text="🛒"
              name=""
              onClick={onAddCartButtonClick}
              visible={CFVisible}
              hint="CF"
            /> 
             {/* <Button
              text="All Q"
              name=""
              onClick={handleShow}
              hint="Queue"
              width={50}
            /> */}
          </Column>

          <Column dataField="ALL_Q" caption="ALL Q" width={70} />

          {/* <Column type="buttons" caption="Note">
        <Button
              text="📜"
              name=""
              onClick={onViewNoteButtonClick}
              visible={haveNoteVisible}
              hint="Have Note"
              width={50}
            />
            <Button
              text="🧾"
              name=""
              onClick={onViewNoteButtonClick}
              visible={NotHaveNoteVisible}
              hint="Not Have Note"
              width={50}
            />
          </Column> */}
          <Column dataField="CARRIER" caption="Carrier" width={100} />
          <Column dataField="POD" />
          <Column dataField="CONTAINER_TYPE" caption="Type" />
          <Column dataField="CTNR_20" caption="20'" width={60} />
          <Column dataField="CTNR_40" caption="40'" width={60} />
          <Column dataField="CTNR_40HQ" caption="40HQ" width={60} />
          <Column
            dataField="CANCEL_BKG_CUTOFF_DATE"
            caption="Cancel Cutoff"
            allowHiding={false}
            width={120}
            dataType="date"
            format="dd-MMM-yyyy"
            defaultSortOrder="asc"
          />

          <Column
            dataField="CONTAINER_CUTOFF_TIME"
            caption="CTNR Cutoff"
            dataType="date"
            format="dd-MMM-yyyy HH:mm aa"
          />
          <Column
            dataField="ETD"
            allowHiding={false}
            dataType="date"
            format="dd-MMM-yyyy"
          />
          <Column dataField="CF_NAME" caption="CF_NAME" visible={false} />
          <Column dataField="CS_NAME" caption="CS" allowHiding={false} />
          <Column dataField="SALES_NAME" caption="Sales" allowHiding={false} />
          <Column
            dataField="SHIPPER"
            caption="Shipper"
            allowHiding={false}
            width={200}
          />
          <Column dataField="NOTE" visible={false} />
          <Summary>
            <TotalItem column="BOOKING_NO" summaryType="count" />

            {/* <TotalItem column="CTNR_20" summaryType="sum" />
            <TotalItem column="CTNR_40" summaryType="sum" />
            <TotalItem column="CTNR_40HQ" summaryType="sum" /> */}
          </Summary>
          <LoadPanel enabled={loadPanelEnabled} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
    
  );
  

}

